// extracted by mini-css-extract-plugin
module.exports = {"answerCount":"ReadAnswers_answerCount__2Y-wC","arrow":"ReadAnswers_arrow__15KQ1","open":"ReadAnswers_open__2JEjn"};